import { Collection } from '../../types/database.type';

export enum WebsiteCategory {
  WASTE_DISPOSAL = 'waste-disposal',
  MEDIA_CONSUMPTION = 'media-consumption',
  LAND_REGISTER = 'land-register',
  OTHER = 'other',
}

export interface WebsiteCategoryData {
  key: string;
  path: string;
  icon: string;
}

export interface WebsiteData {
  id: string;
  name: string;
  address: string;
  icon: string | null;
}

export interface WebsiteLocalData {
  id: string;
  estateId: string;
  enabled: boolean;
  priority: number;
  name: string | null;
  category: WebsiteCategory | null;
  subcategory?: string | null;
  tags?: string[] | null;
}

export type WebsiteLocalObject = Collection<WebsiteLocalData | null>;
